// Markets Geo Popup JavaScript
// This file handles all the functionality for the markets geo popup

(function () {
  "use strict";
  const COOKIE_NAME = "markets-geo-country";
  const SESSION_DISMISS_KEY = "markets-geo-popup-dismissed";

  // Function to update location content based on country
  function updateLocationContent(locationContent, country) {
    // Hide all location content first
    hideAllLocationContent(locationContent);
    showLocationContent(locationContent, country);
  }

  // Function to check if user is in wrong market and should see popup
  function checkMarketMismatch() {
    // Don't run geolocation targeting if we're in theme customizer
    if (window.Shopify && window.Shopify.designMode) {
      console.log(
        "Theme customizer mode detected, skipping geolocation targeting"
      );
      return;
    }

    // Check if auto-show on mismatch is enabled
    const popupSection = document.querySelector("[data-markets-geo]");
    if (!popupSection) return;

    let detectedCountry = getGeolocationFromCookie();
    if (detectedCountry) {
      checkMarketMismatchWithCountry(detectedCountry);
    } else {
      // If no cached data, fetch from API
      console.log(
        "No cached geolocation, fetching from API for market check..."
      );
      fetch("/browsing_context_suggestions.json")
        .then((response) => {
          if (!response.ok) {
            throw new Error("Response not ok");
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.detected_values && data.detected_values.country) {
            detectedCountry = data.detected_values.country;
            const countryCode = detectedCountry.handle;
            saveGeolocationToCookie(countryCode, 7);
            checkMarketMismatchWithCountry(countryCode);
          }
        })
        .catch((error) => {
          console.log("Could not detect location for market check:", error);
        });
    }
  }

  // Function to check market mismatch with a given country
  function checkMarketMismatchWithCountry(detectedCountry) {
    const currentCountry = window.Shopify && window.Shopify.country;
    if (currentCountry && detectedCountry !== currentCountry) {
      showPopupForMarketMismatch();
    }
  }

  // Function to show popup for market mismatch
  function showPopupForMarketMismatch() {
    if (!shouldShowPopup()) return;

    const popup = document.querySelector("[data-markets-geo]");
    if (popup && !popup.hasAttribute("open")) {
      detectLocationAndUpdateContent();
      popup.setAttribute("open", "");
      popup.classList.add("is-visible");
    }
  }

  // Helper function to hide all location content
  function hideAllLocationContent(locationContent) {
    const allContent = locationContent.querySelectorAll(
      "[data-location-content]"
    );
    allContent.forEach((content) => content.classList.add("hidden"));
  }

  // Helper function to show specific location content
  function showLocationContent(locationContent, userCountry) {
    const userCountryLower = userCountry.toLowerCase();
    const content =
      Array.from(
        locationContent.querySelectorAll("[data-location-content]")
      ).find((el) =>
        el.dataset.locationContent.toLowerCase().includes(userCountryLower)
      ) || locationContent.querySelector(`[data-location-content="default"]`);
    const parentContent = locationContent.closest("[data-location-content]");
  
    if (content) {
      content.classList.remove("hidden");
      parentContent.classList.remove("hidden");
    } else {
      parentContent.classList.add("hidden");
    }
  }

  // Function to detect location and update content
  function detectLocationAndUpdateContent() {
    const locationContent = document.querySelector(
      "[data-markets-geo] [data-location-content]"
    );
    const countrySelector = document.querySelector(
      '[data-markets-geo] [name="country_code"]'
    );
    console.log("countrySelector", countrySelector, locationContent);
    if (!locationContent || !countrySelector) return;

    const selectedCountry = countrySelector.value;
    updateLocationContent(locationContent, selectedCountry);
  }

  // Helper functions for geolocation
  function getGeolocationFromCookie() {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split("=");
      if (name === COOKIE_NAME) {
        return value;
      }
    }
    return null;
  }

  function saveGeolocationToCookie(countryCode, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${COOKIE_NAME}=${countryCode};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
  }

  // Initialize custom popout functionality
  function initializeCustomPopout() {
    const customPopout = document.querySelector(
      "[data-markets-geo] [data-custom-popout]"
    );
    if (!customPopout) return;

    const toggle = customPopout.querySelector("[data-custom-popout-toggle]");
    const list = customPopout.querySelector("[data-custom-popout-list]");
    const options = customPopout.querySelectorAll(
      "[data-custom-popout-option]"
    );
    const input = customPopout.querySelector("[data-custom-popout-input]");

    if (!toggle || !list || !input) return;

    toggle.addEventListener("click", () => {
      const isExpanded = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", !isExpanded);
      list.classList.toggle("is-visible", !isExpanded);
    });

    options.forEach((option) => {
      option.addEventListener("click", () => {
        const value = option.getAttribute("data-value");
        const displayText = option.innerHTML;

        input.value = value;

        const toggleText = customPopout.querySelector(
          "[data-custom-popout-toggle-text]"
        );
        if (toggleText) {
          toggleText.innerHTML = displayText;
        }

        options.forEach((opt) =>
          opt.parentElement.classList.remove("is-active")
        );
        option.parentElement.classList.add("is-active");

        toggle.setAttribute("aria-expanded", "false");
        list.classList.remove("is-visible");

        input.dispatchEvent(new Event("change"));

        setTimeout(detectLocationAndUpdateContent, 100);
      });
    });

    // Close popout when clicking outside
    document.addEventListener("click", (event) => {
      if (!customPopout.contains(event.target)) {
        toggle.setAttribute("aria-expanded", "false");
        list.classList.remove("is-visible");
      }
    });

    // Safari iOS touch event handling
    let touchStartY = 0;
    let touchStartTime = 0;
    
    list.addEventListener("touchstart", (event) => {
      touchStartY = event.touches[0].clientY;
      touchStartTime = Date.now();
    }, { passive: true });
    
    list.addEventListener("touchmove", (event) => {
      // Allow scrolling on the dropdown list
      const touchY = event.touches[0].clientY;
      const touchTime = Date.now();
      const deltaY = Math.abs(touchY - touchStartY);
      const deltaTime = touchTime - touchStartTime;
      
      // If it's a quick swipe or significant movement, allow scrolling
      if (deltaY > 10 || deltaTime > 100) {
        event.stopPropagation();
      }
    }, { passive: true });
  }

  // Handle popup close events
  function initializePopupCloseButton() {
    const closeButtons = document.querySelectorAll("[data-markets-geo-close]");

    closeButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();

        const popup = document.querySelector("[data-markets-geo]");
        if (popup) {
          popup.close ? popup.close() : popup.removeAttribute("open");
          popup.classList.remove("is-visible");
          sessionStorage.setItem(SESSION_DISMISS_KEY, "session");
        }
      });
    });
  }

  // Handle popup submit events
  function initializePopupSubmitButton() {
    const submitButton = document.querySelector("[data-popup-submit]");
    if (!submitButton) return;

    submitButton.addEventListener("click", (event) => {
      sessionStorage.setItem(SESSION_DISMISS_KEY, "session");
    });
  }

  // Handle popup open events
  function initializePopupOpenButton() {
    document.addEventListener("click", (event) => {
      const openButton = event.target.closest("[data-markets-geo-open]");
      if (openButton) {
        event.preventDefault();

        const popup = document.querySelector("[data-markets-geo]");
        if (popup) {
          detectLocationAndUpdateContent();
          popup.showModal ? popup.showModal() : popup.setAttribute("open", "");
          popup.classList.add("is-visible");
        }
      }
    });
  }

  // Check if popup should be shown based on user preferences
  function shouldShowPopup() {
    // Check if we're in theme customizer (always show)
    if (window.Shopify && window.Shopify.designMode) return true;

    // Don't show on form submission page reloads (e.g. newsletter sign-up)
    const search = window.location.search;
    if (
      search.indexOf("customer_posted=true") !== -1 ||
      search.indexOf("contact_posted=true") !== -1 ||
      search.indexOf("form_type=customer") !== -1
    ) {
      return false;
    }

    // Check session dismiss
    const sessionDismiss = sessionStorage.getItem(SESSION_DISMISS_KEY);
    if (sessionDismiss === "session") return false;

    return true;
  }

  document.addEventListener("DOMContentLoaded", () => {
    checkMarketMismatch();
    initializeCustomPopout();
    initializePopupCloseButton();
    initializePopupSubmitButton();
    initializePopupOpenButton();
  });
})();
